(function () {
  var script = document.currentScript;
  var localeRoot = script && script.dataset.localeRoot;

  if (!localeRoot || localeRoot === '/') return;

  var normalizedRoot = '/' + localeRoot.replace(/^\/+|\/+$/g, '') + '/';

  function localizeUrl(value) {
    if (!value || value.charAt(0) !== '/' || value.indexOf('//') === 0) return value;
    if (value === normalizedRoot.slice(0, -1) || value.indexOf(normalizedRoot) === 0) return value;
    return normalizedRoot.slice(0, -1) + value;
  }

  function localizeElement(element) {
    if (element.matches('a[href^="/"]:not([data-disclosure-option])')) {
      element.setAttribute('href', localizeUrl(element.getAttribute('href')));
    }

    if (element.matches('form[action^="/"]:not([data-disclosure-form])')) {
      element.setAttribute('action', localizeUrl(element.getAttribute('action')));
    }

    if (element.matches('[data-link^="/"]')) {
      element.setAttribute('data-link', localizeUrl(element.getAttribute('data-link')));
    }
  }

  function localizeTree(root) {
    if (root.nodeType === 1) localizeElement(root);
    root.querySelectorAll('a[href^="/"], form[action^="/"], [data-link^="/"]').forEach(localizeElement);
  }

  localizeTree(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) localizeTree(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
